import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deputaion-sanction-form',
  templateUrl: './deputaion-sanction-form.component.html',
  styleUrls: ['./deputaion-sanction-form.component.css']
})
export class DeputaionSanctionFormComponent implements OnInit {
  title="Add Deputation Sanction";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/deputaion/deputaion-sanction/deputaion-sanction-form/deputaion-sanction-form.component.ts